import React, { useEffect, useState } from "react";
import "./styles.scss";
import "./mobile.scss";
import {
  Button,
  ButtonIcon,
  CommentCardNew,
  InputBox,
  JobCard,
  JobViewCard,
  NewsGroup,
  PageNavigation,
  TextArea,
  TopMenu,
} from "../../components";
import { setTheme } from "../../utils/themes";
import { getLanguage } from "../../utils/environment";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import {
  ConsoleTopLeftAdd,
  ConsoleTopRightAdd,
  NewsViewLeftBottomAdd,
  HomePageCenterAdd,
  NewsViewRightTopAdd,
} from "../templates/advertiesments";
import Footer from "../footer/index";
import HotNewsSmall from "../templates/hotNewsSmall";
import {
  EmailChangeModal,
  EmailVerificationModal,
  MobileMenuModal,
} from "../modal";
import Menu from "../templates/menu";
import { GetIconByName } from "../../config/icon";
import { openMobileMenuModal, setNewsUser } from "../console/redux/actions";
import {
  downloadJobApplication,
  getAllJobsCategory,
  getJobById,
} from "../CreateNewItem/CreateNewJob/service/jobs.service";
import {
  CheckValidity,
  getInsight,
  setAdsSession,
  setInsight,
} from "../../utils";
import { setJobCategoryList, setJobs } from "../Jobs/redux/actions";
import { createNewInsight } from "../console/services/insight.service";
import {
  addJobComment,
  addNewJobImpression,
  addNewJobsDownloadImpression,
} from "../GovernmentJobsPage/service/jobs.service";
import { getIPAddress } from "../../utils/browserMeta";
import { getNewsByTags } from "../newsViewPage/service/news.service";
import RelatedNews from "../templates/relatedNews";
import { Dropdown, notification } from "antd";
import { Store } from "react-notifications-component";
import { getExistingByUserName } from "../AdsSignIn/service/auth.service";
import {
  createNewAdsCompany,
  createNewEmailVerification,
} from "../AdsSignUp/services/adsSignup.service";
import { openEmailVerificationModal } from "../AdsPlatform/redux/actions";
import { addNewsComment } from "../news/service/news.service";
import HomeAdViewModal from "../modal/homeAdViewModal";
const lan = getLanguage();

const Index = (props) => {
  const [category, setCategory] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);
  const [jobCategory, setJobCategory] = React.useState([]);
  const [jobId, setJobId] = useState("");
  const [jobDetails, setJobDetails] = useState("");
  const [newsUpdateList, setNewsUpdateList] = React.useState([]);
  const [currentUrl, setCurrentUrl] = React.useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [showAllComments, setShowAllComments] = useState(false);
  const [isSticky, setIsSticky] = useState(false);

  const [formData, setFormData] = React.useState({
    firstName: {
      key: "firstName",
      label: "First name",
      size: "lg",
      isShowRequired: true,
      elementConfig: {
        type: "text",
        placeholder: "How we call you",
      },
      validation: {
        required: true,
      },
      touched: false,
      isValid: false,
      invalidReason: "",
      value: "",
      isRequired: true,
    },
    email: {
      key: "email",
      label: "Working email address",
      size: "lg",
      isShowRequired: true,
      elementConfig: {
        type: "text",
        placeholder: "Enter you working email address",
      },
      validation: {
        required: true,
        email: true,
      },
      touched: false,
      isValid: false,
      isLoading: false,
      invalidReason: "",
      value: "",
      isRequired: true,
    },
    comment: {
      key: "comment",
      label: "",
      size: "lg",
      elementConfig: {
        type: "text",
        placeholder: "Write a comment here",
      },
      touched: false,
      validation: {
        required: false,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    newsUrl: {
      key: "newsUrl",
      label: "",
      size: "lg disable mt-3",
      elementConfig: {
        type: "text",
        placeholder: "",
        disable: true,
      },
      disabled: true,
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const dispatch = useDispatch();
  const { isOpenMobileMenuModal, isOpenAd } = useSelector(
    ({ consoleReducer }) => consoleReducer,
  );
  const { isOpenEmailVerificationModal, isOpenEmailChangeModal } = useSelector(
    ({ adsUserReducer }) => adsUserReducer,
  );
  const { selectJobs, jobCategoryList } = useSelector(
    ({ jobsReducer }) => jobsReducer,
  );

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY >= 20);
      // console.log(window.scrollY);
    };
    window.scrollTo({ top: 0, behavior: "smooth" });
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  async function handleInsight(jobId, categoryId) {
    let insightBody = {};
    try {
      console.log({ jobId, categoryId });
      // Get the geolocation
      // const position = await getGeoLocation();
      // const { latitude, longitude, accuracy, timestamp } = position?.coords;

      // Wait for all promises to resolve
      const [ip] = await Promise.all([
        // getLocationName(latitude, longitude),
        getIPAddress(),
      ]);

      // Construct the insight body
      insightBody = {
        insight_id: null,
        ip,
        platform: "https://hopeofanewera.org/",
        // user: sessionUser?.userId,
      };

      const insight = await getInsight();
      // Additional logic for when the insight is found
      if (insight?.insight_id) {
        console.log("userInsight_insight_found", insight);
        insightBody.insight_id = insight.insight_id;
        let impressionBody = {
          insight_id: insight.insight_id,
          job_id: jobId,
          category_id: categoryId,
          ip_address: ip,
        };

        let resImpression = await addNewJobImpression(impressionBody);
        console.log("addNew_Job_Impression::", resImpression);
        // setNews({ ...news, views: (news?.views || 0) + 1 });
      }
    } catch (error) {
      console.log("No insight found", error);
      try {
        const insightResponse = await createNewInsight(insightBody);
        console.log("Created new insight:", insightResponse);
        if (
          insightResponse?.data?.status ||
          insightResponse?.data?.data !== ""
        ) {
          await setInsight(insightResponse?.data?.data?.token);
          let impressionBody = {
            insight_id: insightResponse?.data?.data?.insight_id,
            job_id: jobId,
            category_id: categoryId,
            ip_address: insightBody.ip,
          };

          let resImpression = await addNewJobImpression(impressionBody);
          console.log("addNew_Job_Impression::", resImpression);
          // setNews({ ...news, views: (news?.views || 0) + 1 });
        }

        // Additional logic for when the insight is not found and a new one is created
      } catch (creationError) {
        console.error("Error creating new insight:", creationError);
        // Handle the error that occurred during the creation of a new insight
      }
    }
  }

  const fetchNewsByTags = async (tag_list) => {
    let param = window.location.pathname.split("/");
    let news_id = param?.[2];
    if (tag_list?.length > 0) {
      let result = await getNewsByTags(lan, { tag_ids: tag_list });
      console.log("tag news::", result?.data?.news);
      if (result?.data?.news?.length > 0) {
        let newsList = result?.data?.news;

        // if (
        //   newsList?.length === 1 &&
        //   newsList?.find((news) => news?.news_id === news_id)
        // ) {
        //   setNewsUpdateList(
        //     newsList?.filter((x) => x.news_id !== news_id)?.map((x) => x)
        //   );
        //   return;
        // }
        setNewsUpdateList(result?.data?.news);
      } else {
        setNewsUpdateList([]);
      }
    }
  };

  async function fetchPageData() {
    let param = window.location.pathname.split("/");
    console.log({ param });
    try {
      if (param.length > 2) {
        const jobIdPram = param[3];

        setJobId(jobIdPram);

        let updateFormData = { ...formData };

        updateFormData["newsUrl"].value =
          lan === "si"
            ? "https://sinhala.hopeofanewera.org/jobs/" +
              decodeURIComponent(param[2])?.toString() +
              "/" +
              jobIdPram
            : "https://hopeofanewera.org/jobs/" +
              decodeURIComponent(param[2])?.toString() +
              "/" +
              jobIdPram;
        setCurrentUrl(
          lan === "si"
            ? "https://sinhala.hopeofanewera.org/jobs/" +
                decodeURIComponent(param[2])?.toString() +
                "/" +
                jobIdPram
            : "https://hopeofanewera.org/jobs/" +
                decodeURIComponent(param[2])?.toString() +
                "/" +
                jobIdPram,
        );
        try {
          const response = await getJobById(jobIdPram);
          console.log("get job", response);
          if (response?.data) {
            const job = response?.data;
            console.log("get job comments", job?.comments);
            await fetchNewsByTags(job?.tags);
            setJobDetails(job);
            dispatch(setJobs(job));
            setFormData(updateFormData);
            await handleInsight(jobIdPram, job?.organization);
          } else {
            console.log("get job-not-found", response);
            setJobDetails("");
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    } catch (error) {
      console.error("Error fetching page data:", error);
    }
  }

  useEffect(() => {
    setTheme("light");

    let param = window.location.pathname.split("/");
    console.log({ param });

    const jobIdPram = param?.[2];
    if (jobDetails?.job_id !== "" && jobDetails?.job_id !== jobIdPram) {
      async function fetchData() {
        try {
          // Fetch existing insight if it exists
          await fetchPageData();
        } catch (error) {
          console.error("Error in userInsight:", error);
        }
      }
      fetchData();
    }
  }, []);

  const updateContactForm = { ...formData };

  const handleChange = async (event, inputIdentity) => {
    const updateContactForm = {
      ...formData,
    };

    updateContactForm[inputIdentity].value = event;

    let validityRes = await CheckValidity(
      inputIdentity,
      updateContactForm[inputIdentity].value,
      updateContactForm[inputIdentity].validation,
    );
    if (validityRes) {
      updateContactForm[inputIdentity].isValid = validityRes.isValid;
      updateContactForm[inputIdentity].invalidReason = validityRes.reason;
      updateContactForm[inputIdentity].touched = true;

      // updateContactForm[inputIdentity] = updatedFormElement;
      let formIsValid = false;
      for (let inputIdentifier in updateContactForm) {
        formIsValid = updateContactForm[inputIdentifier].valid && formIsValid;
      }

      setFormData(updateContactForm);
    }
  };

  const clearAll = () => {
    const updateNewsForm = {
      ...formData,
    };
    for (let key in updateNewsForm) {
      if (key === "newsUrl") {
        continue;
      }
      updateNewsForm[key].value = "";
      updateNewsForm[key].isValid = false;
      updateNewsForm[key].touched = false;
    }
    setFormData(updateNewsForm);
  };

  const saveUserCompany = async () => {
    setIsLoading(true);
    let updateFormData = { ...formData };

    let body = {
      company_name: updateFormData.firstName.value,
      company_logo: "",
      company_website: "",
      working_email: updateFormData.email.value,
      password: "user@123",
      contact_no: "",
      company_type: "user",
    };

    try {
      let res = await createNewAdsCompany(body);
      console.log("res", res);
      if (res?.data?.status) {
        setIsLoading(false);
        // setUserSession(res?.data?.token);
        let resVerify = await createNewEmailVerification({
          company_id: res?.data?.data?.company_id,
          email: res?.data?.data?.working_email,
        });
        console.log("resVerify", resVerify.data);
        if (resVerify.data.status) {
          setAdsSession(resVerify.data?.data?.token);
          // props.history.push("/ads/verification");
          dispatch(
            openEmailVerificationModal({
              user: res?.data?.data,
              token: resVerify.data?.data?.token,
            }),
          );
          window.scrollTo({ top: 0, behavior: "smooth" });
        } else {
          notification.error({
            message: "Error",
            description: resVerify.data.message,
          });
        }
        dispatch(setNewsUser(res?.data?.data));
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      console.log("error", error);
    }
    setIsLoading(false);
  };

  const onClickAddComment = async () => {
    setIsLoading(true);

    const updateForm = { ...formData };
    let insight = await getInsight();

    try {
      let isExisting = await getExistingByUserName({
        email: updateForm.email.value,
      });
      console.log("isExisting", isExisting);
      if (isExisting?.data?.status) {
        if (!isExisting?.data?.data?.isAccountVerified) {
          let resVerify = await createNewEmailVerification({
            company_id: isExisting?.data?.data?.company_id,
            email: isExisting?.data?.data?.working_email,
          });
          console.log("resVerify", resVerify.data);
          if (resVerify.data.status) {
            setAdsSession(resVerify.data?.data?.token);
            setIsLoading(false);
            dispatch(
              openEmailVerificationModal({
                user: isExisting?.data?.data,
                token: resVerify.data?.data?.token,
              }),
            );

            window.scrollTo({ top: 0, behavior: "smooth" });
          } else {
            notification.error({
              message: "Error",
              description: resVerify.data.message,
            });
            setIsLoading(false);
          }
        } else {
          const response = await addJobComment(
            {
              insight_id: insight?.insight_id || null,
              first_name: updateForm.firstName.value,
              email: updateForm.email.value,
              comment: updateForm.comment.value,
            },
            jobId,
          );

          if (response.data?.status) {
            setIsLoading(false);
            setIsOpen(false);
            // await saveUserCompany();
            await fetchPageData();
            clearAll();
          } else {
            setIsLoading(false);
            Store.addNotification({
              title: "Error!",
              message: response?.data?.message || "Feedback sending Failed!",
              type: "danger",
              insert: "top",
              container: "top-right",
              dismiss: {
                duration: 3000,
                onScreen: true,
              },
            });
          }
        }
      } else {
        try {
          await saveUserCompany();
        } catch (error) {
          console.error({ error });
        }
        const response = await addJobComment(
          {
            insight_id: insight?.insight_id || null,
            first_name: updateForm.firstName.value,
            email: updateForm.email.value,
            comment: updateForm.comment.value,
          },
          jobId,
        );

        if (response.data?.status) {
          setIsLoading(false);
          setIsOpen(false);
          await fetchPageData();
          clearAll();
        } else {
          setIsLoading(false);
          Store.addNotification({
            title: "Error!",
            message: response?.data?.message || "Feedback sending Failed!",
            type: "danger",
            insert: "top",
            container: "top-right",
            dismiss: {
              duration: 3000,
              onScreen: true,
            },
          });
        }
      }
    } catch (error) {
      setIsLoading(false);
      Store.addNotification({
        title: "Error!",
        message: "Feedback sending Failed!",
        type: "danger",
        insert: "top",
        container: "top-right",
        dismiss: {
          duration: 3000,
          onScreen: true,
        },
      });
      setIsLoading(false);
    }
  };

  async function handleInsightDownload(jobId, categoryId) {
    let insightBody = {};
    try {
      console.log({ jobId, categoryId });
      // Get the geolocation
      // const position = await getGeoLocation();
      // const { latitude, longitude, accuracy, timestamp } = position?.coords;

      // Wait for all promises to resolve
      const [ip] = await Promise.all([
        // getLocationName(latitude, longitude),
        getIPAddress(),
      ]);

      // Construct the insight body
      insightBody = {
        insight_id: null,
        ip,
        platform: "https://hopeofanewera.org/",
        // user: sessionUser?.userId,
      };

      console.log("userInsight_insightBody:", insightBody);
      const insight = await getInsight();
      console.log("Insight found", insight);
      // Additional logic for when the insight is found
      if (insight?.insight_id) {
        console.log("userInsight_insight_found", insight);
        insightBody.insight_id = insight.insight_id;
        let impressionBody = {
          insight_id: insight.insight_id,
          job_id: jobId,
          category_id: categoryId,
          ip_address: ip,
        };

        let resImpression = await addNewJobsDownloadImpression(impressionBody);
        console.log("addNew_Job_Impression::", resImpression);
        // setNews({ ...news, views: (news?.views || 0) + 1 });
      }
    } catch (error) {
      console.log("No insight found", error);
      try {
        const insightResponse = await createNewInsight(insightBody);
        console.log("Created new insight:", insightResponse);
        if (
          insightResponse?.data?.status ||
          insightResponse?.data?.data !== ""
        ) {
          await setInsight(insightResponse?.data?.data?.token);
          let impressionBody = {
            insight_id: insightResponse?.data?.data?.insight_id,
            job_id: jobId,
            category_id: categoryId,
            ip_address: insightBody.ip,
          };

          let resImpression =
            await addNewJobsDownloadImpression(impressionBody);
          console.log("addNew_Job_Impression::", resImpression);
          // setNews({ ...news, views: (news?.views || 0) + 1 });
        }

        // Additional logic for when the insight is not found and a new one is created
      } catch (creationError) {
        console.error("Error creating new insight:", creationError);
        // Handle the error that occurred during the creation of a new insight
      }
    }
  }

  const handleChildData = (childData) => {
    // props.onChangeCategory(childData); // Update state with child data
    setCategory(childData);
  };

  // const openWindow = (imgUrl) => {
  //   const newWindow = window.open("", "", "width=1024,height=920");
  //   if (newWindow) {
  //     newWindow.document.write(`
  //     <html>
  //       <head>
  //         <title>New Window</title>
  //       </head>
  //       <body style="margin:0; padding:0; display:flex; justify-content:center; align-items:center; height:100vh;">
  //       <div>
  //         <div className={"cw__advertiesment-wrapper"}>
  //           <div className="top-ad active">
  //
  //           </div>
  //           <div className="top-ad active">
  //
  //           </div>
  //         </div>
  //         <img src="${imgUrl}" alt="job details sinhala" style="max-width:100%; max-height:100%;" />
  //       </div>
  //       </body>
  //     </html>
  //   `);
  //     newWindow.document.close();
  //   }
  // };

  const openWindow = async (imgUrl) => {
    const adUrlRight = process.env.REACT_APP_HOME_TOP_RIGHT_ADV;
    const adUrlLeft = process.env.REACT_APP_HOME_TOP_LEFT_ADV;

    const insight = await getInsight(); // Assuming this returns { insight_id }

    // const isPdf = imgUrl.endsWith(".pdf");
    let previewElement = "";
    console.log("Array.isArray(imgUrl)", Array.isArray(imgUrl));
    if (Array.isArray(imgUrl)) {
      previewElement = imgUrl
        .map((img, id) => {
          const src = img?.file_url;
          if (src?.endsWith(".pdf")) {
            return `<iframe src="${src}" alt="${id}" class="responsive-content"></iframe>`;
          } else {
            return `<img src="${src}" alt="${id}" class="responsive-content" />`;
          }
        })
        .join("");
    } else {
      previewElement = imgUrl?.endsWith(".pdf")
        ? `<iframe src="${imgUrl}" alt="PDF" class="responsive-content"></iframe>`
        : `<img src="${imgUrl}" alt="job details sinhala" class="responsive-content" />`;
    }

    const newWindow = window.open("", "", "width=1024,height=920");
    if (newWindow) {
      const safeAdUrlRight = adUrlRight || "";
      const safeAdUrlLeft = adUrlLeft || "";

      newWindow.document.write(`
    <html>
      <head>
        <title>Preview</title>
        <style>
          html, body {
            margin: 0;
            padding: 0;
            height: 100%;
            width: 100%;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
          }

          .advertisement-wrapper {
            display: flex;
            flex-direction: row;
            justify-content: center;
            gap: 10px;
            height: 80px;
            flex-shrink: 0;
          }

          .top-ad {
            flex: 1;
            height: 100%;
          }

          .top-ad iframe {
            width: 100%;
            height: 100%;
            border: none;
          }

          .content-container {
            flex: 1;
            /*overflow: auto;*/
            display: flex;
            justify-content: center;
            align-items: center;
            background: #f8f8f8;
          }

          .responsive-content {
            max-width: 100%;
            max-height: 100%;
            width: 100%;
            height: 100%;
            object-fit: contain;
            border: none;
          }
        </style>
      </head>
      <body>
        <div class="advertisement-wrapper">
          <div class="top-ad">
            <iframe id="adFrameLeft" src="${safeAdUrlLeft}" loading="lazy"></iframe>
          </div>
          <div class="top-ad">
            <iframe id="adFrameRight" src="${safeAdUrlRight}" loading="lazy"></iframe>
          </div>
        </div>
        <div class="content-container"  style="display: flex; flex-direction: column;">
          ${previewElement}
        </div>
        <script>
          window.addEventListener('load', function () {
            const iframeLeft = document.getElementById('adFrameLeft');
            const iframeRight = document.getElementById('adFrameRight');

            iframeLeft?.addEventListener('load', function () {
              iframeLeft.contentWindow?.postMessage(
                { insight_id: "${insight?.insight_id || ""}" },
                "${safeAdUrlLeft}"
              );
            });

            iframeRight?.addEventListener('load', function () {
              iframeRight.contentWindow?.postMessage(
                { insight_id: "${insight?.insight_id || ""}" },
                "${safeAdUrlRight}"
              );
            });
          });
        </script>
      </body>
    </html>
  `);
      newWindow.document.close();
    }
  };

  const onClickDownloadApplication = async (job_id, lan) => {
    setIsLoading(true);
    try {
      if (jobDetails?.job_application?.[`${lan}_url`]?.endsWith(".pdf")) {
        const url = jobDetails?.job_application?.[`${lan}_url`];

        if (url.endsWith(".pdf")) {
          window.open(url, "_blank");
        } else {
          const a = document.createElement("a");
          a.href = url;
          a.download = `job_${job_id}_${lan}`;
          document.body.appendChild(a);
          a.click();
          a.remove();
        }
        setIsLoading(false);
      } else {
        let response = await downloadJobApplication(job_id, lan);
        console.log("response download::", response);
        if (response?.data) {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);

          const a = document.createElement("a");
          a.href = url;
          a.download = `job_${job_id}_${lan}.pdf`; // Optional: Make dynamic with job_id
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);

          alert("Downloaded");
          setIsLoading(false);
          window.scrollTo(0, 0);
        }
      }

      await handleInsightDownload(job_id, jobDetails?.organization);
      // setIsLoading(false);
    } catch (error) {
      console.log({ error });
      setIsLoading(false);
    }
  };

  const fetchCategories = async () => {
    const response = await getAllJobsCategory();
    if (response?.data) {
      setJobCategory(response.data);
      dispatch(setJobCategoryList(response.data));
    }
  };

  const fetchCategoryName = (id) => {
    const isExist = jobCategoryList?.find((x) => x?.job_category_id === id);
    return isExist?.jobs_category_name;
  };

  const addComment = (
    <div className={"contact-form news"}>
      <div
        className="common-modal-close"
        style={{
          marginTop: "-16px",
        }}
      >
        <ButtonIcon
          data={{ iconName: "cross", size: "sm" }}
          onClick={() => {
            setIsOpen(false);
            setIsLoading(false);
          }}
        />
      </div>
      <InputBox
        data={updateContactForm.firstName}
        onChange={async (e) => {
          e.preventDefault();
          await handleChange(e.target.value, updateContactForm.firstName.key);
        }}
      />
      <InputBox
        data={updateContactForm.email}
        onChange={async (e) => {
          e.preventDefault();
          await handleChange(e.target.value, updateContactForm.email.key);
        }}
      />
      <Button
        data={{
          mainLayerStyles: "mt-3",
          btnName: "Done",
          buttonType:
            updateContactForm.firstName.value === "" ||
            updateContactForm.email.value === "" ||
            updateContactForm.comment.value === ""
              ? "primary disabled"
              : "primary",
          buttonSize: "lg",
          isLoading: isLoading,
          disable:
            updateContactForm.firstName.value === "" ||
            updateContactForm.email.value === "" ||
            updateContactForm.comment.value === ""
              ? true
              : false,
        }}
        onClick={async () => {
          try {
            await onClickAddComment();
          } catch (err) {
            setIsLoading(false);

            console.error(
              "Comment add failed:",
              err,
              updateContactForm.firstName.value === "" ||
                updateContactForm.email.value === "" ||
                updateContactForm.comment.value === "",
            );
          }
        }}
      />
    </div>
  );

  const handleCopy = () => {
    let param = window.location.pathname.split("/");
    let keyword = param?.[2];
    const actualUrl =
      lan === "si"
        ? "https://sinhala.hopeofanewera.org/jobs/" +
          decodeURIComponent(keyword)?.toString() +
          "/" +
          jobId
        : "https://hopeofanewera.org/jobs/" +
          decodeURIComponent(keyword)?.toString() +
          "/" +
          jobId;
    navigator.clipboard.writeText(actualUrl).then(() => {
      notification.success({ message: "Link copied to clipboard!" });
    });
  };

  useEffect(() => {
    if (jobCategoryList?.length === 0) {
      fetchCategories();
    }
  }, []);

  // const currentUrl = window.location.href;
  const title = encodeURIComponent(
    jobDetails?.job_title?.[lan] || "Hope of a New Era",
  );
  const image = encodeURIComponent(
    jobDetails?.banner_img?.file_url || jobDetails?.banner_img || "",
  );

  const sortedComments = [...(jobDetails?.comments || [])].sort(
    (a, b) => new Date(b.created_at) - new Date(a.created_at),
  );

  const displayedComments = showAllComments
    ? [...(jobDetails?.comments || [])]?.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at),
      )
    : sortedComments.slice(0, 2);

  return (
    <>
      <Helmet>
        <title>{jobDetails?.job_title?.[lan] || "Government jobs"}</title>
        <meta
          name="description"
          content={
            jobDetails?.summary?.[lan]?.slice(0, 150) || "Government jobs."
          }
        />
        <meta property="og:title" content={jobDetails?.job_title?.[lan]} />
        <meta
          property="og:description"
          content={jobDetails?.description?.[lan]?.slice(0, 150)}
        />
        <meta property="og:image" content={jobDetails?.banner_img?.file_url} />
        <meta property="og:url" content={window.location.href} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={window.location.href} />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "NewsArticle",
            headline: jobDetails?.job_title?.[lan],
            image: [jobDetails?.banner_img?.file_url],
            datePublished: jobDetails?.created_at,
            dateModified: jobDetails?.updated_at || jobDetails?.created_at,
            author: {
              "@type": "Organization",
              name: "Hope of a New Era",
            },
            publisher: {
              "@type": "Hope of a New Era",
              name: "Hope of a New Era",
              logo: {
                "@type": "ImageObject",
                url: "https://example.com/logo.png",
              },
            },
          })}
        </script>
      </Helmet>
      <>
        {isOpenMobileMenuModal && <MobileMenuModal />}
        {isOpenEmailVerificationModal && <EmailVerificationModal />}
        {isOpenEmailChangeModal && <EmailChangeModal />}
        {isOpenAd && <HomeAdViewModal />}
        <div className={`cw__top-menu ${isSticky ? "sticky" : ""}`}>
          <TopMenu
            data={{
              size: "lg",
              isLanguage: true,
              isLogo: false,
              isProfile: false,
            }}
            onClickPublish={() => {
              props.history.push("/admin");
            }}
          />
        </div>
        <div className={"container"}>
          <div className={`cw__tab ${isSticky ? "sticky" : ""} `}>
            <div className={"cwt__hope"}>
              <img
                src={require("../../assets/img/lgo (1).png")}
                alt={jobDetails?.job_title?.[lan]}
              />
            </div>
            <div className={"menu"}>
              <Menu setMenuName={handleChildData} />
            </div>

            {/* <div
              className={"cwt__menu-mobile"}
              onClick={() => {
                dispatch(openMobileMenuModal());
              }}
            >
              {GetIconByName("menu")}
            </div> */}
          </div>
          <div className={"cw__advertiesment-wrapper"}>
            <div className="bottom-ad-mobile">
              <ConsoleTopRightAdd />
            </div>
            <div className="bottom-ad">
              <ConsoleTopLeftAdd />
              <ConsoleTopRightAdd />
            </div>
          </div>

          <PageNavigation
            data={{
              main: "Government Jobs",
              page: jobDetails?.job_title?.en,
            }}
            onClick={() => props.history.push("/government-jobs")}
          />

          <div className={`gov-jobs-wrapper`}>
            <div className={"gj__special-news-group"}>
              <JobViewCard
                data={{
                  imgUrl:
                    jobDetails?.banner_img?.file_url || jobDetails?.banner_img,

                  titleEn: jobDetails?.job_title?.en,
                  titleSi: jobDetails?.job_title?.si,
                  closingDate: jobDetails?.closing_date,
                  organization:
                    fetchCategoryName(jobDetails?.organization) || "",
                  description: jobDetails?.description,
                  sourceUrl: jobDetails?.source_url,
                  contactNo: jobDetails?.contact_no,
                  email: jobDetails?.email,
                  tags: jobDetails?.tags,
                  gazetteDate: jobDetails?.gazette_date,
                  job_si: jobDetails?.job_details?.si_url,
                  job_ta: jobDetails?.job_details?.ta_url,
                  job_en: jobDetails?.job_details?.en_url,
                  jobApplicationSI: jobDetails?.job_application?.si_url,
                  jobApplicationEN: jobDetails?.job_application?.en_url,
                  views: jobDetails?.views || 0,
                  downloads: jobDetails?.downloads || 0,
                  isLoading: isLoading,
                  type:
                    jobDetails?.job_application_type === "1"
                      ? "download"
                      : jobDetails?.job_application_type === "2"
                        ? "online"
                        : jobDetails?.job_application_type === "3"
                          ? "model"
                          : "",

                  newsList: newsUpdateList,
                }}
                onClickDetailsSI={async () => {
                  await openWindow(jobDetails?.job_details?.si_url);
                }}
                onClickDetailsTA={async () => {
                  await openWindow(jobDetails?.job_details?.ta_url);
                }}
                onClickDetailsEN={async () => {
                  console.log("en", jobDetails?.job_details?.en_url);
                  await openWindow(jobDetails?.job_details?.en_url);
                }}
                onClickDownloadSI={async () => {
                  await onClickDownloadApplication(jobDetails?.job_id, "si");
                }}
                onClickDownloadEN={async () => {
                  await onClickDownloadApplication(jobDetails?.job_id, "en");
                }}
              />

              <div id="container-12e03264376f1867506e14bf4ff8a092"></div>
              {/* share section */}
              <div className={"share_section_wrapper"}>
                <div className="d-flex flex-column mt-3">
                  <div className="d-flex flex-row align-items-center justify-content-between">
                    <div className="nwsng__share mb-1"> Share</div>
                    <div className={"nw__social"}>
                      <div className={"nws__logo"}>
                        <a
                          href={`https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="nws__l-icon"
                        >
                          {GetIconByName("facebook")}
                        </a>
                      </div>
                      <div className={"nws__logo"}>
                        <a
                          href={`https://twitter.com/intent/tweet?text=${title}&url=${currentUrl}&hashtags=HopeOfANewEra&via=HopeNews`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="nws__l-icon"
                        >
                          {GetIconByName("twitter")}
                        </a>
                      </div>
                      <div className={"nws__logo"}>
                        <a
                          href={`https://api.whatsapp.com/send?text=${title}%20${currentUrl}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="nws__l-icon"
                        >
                          {GetIconByName("whatsapp")}
                        </a>
                      </div>
                    </div>
                  </div>
                  <InputBox
                    data={updateContactForm.newsUrl}
                    onChange={async (e) => {
                      e.preventDefault();
                    }}
                  />{" "}
                  <div
                    onClick={handleCopy}
                    style={{ cursor: "pointer" }}
                    title="Copy Link"
                    className={"nws__copy"}
                  >
                    {window.innerWidth < 440 ? "Copy" : "Copy Link"}
                  </div>
                </div>
              </div>
              {/* Comment Section New */}
              <div className={"comment_section_wrapper"}>
                <div>
                  <label className="nwsng__share comment_section">
                    Comments ({jobDetails?.comments?.length || 0})
                  </label>
                  <TextArea
                    data={updateContactForm.comment}
                    onChange={async (e) => {
                      e.preventDefault();
                      await handleChange(
                        e.target.value,
                        updateContactForm.comment.key,
                      );
                    }}
                  />
                  <div className="submit_btn">
                    <Dropdown
                      overlay={addComment}
                      placement="bottomLeft"
                      trigger={["click"]}
                      open={isOpen}
                    >
                      <Button
                        data={{
                          mainLayerStyles: "",
                          btnName: "SUBMIT",
                          buttonType:
                            updateContactForm.comment.value === ""
                              ? "primary disabled"
                              : "primary",
                          buttonSize: "sm-x",
                          isLoading: isLoading,
                          disable:
                            updateContactForm.comment.value === ""
                              ? true
                              : false,
                        }}
                        onClick={async (e) => {
                          e.preventDefault();
                          setIsOpen(!isOpen);
                          // await onClickAddComment(e);
                        }}
                      />
                    </Dropdown>
                  </div>
                </div>
                {jobDetails?.comments?.length === 0 ? (
                  <div className={"no__comments"}>
                    <div className={"nc__icon"}>
                      {GetIconByName("comments")}
                    </div>
                    <div className={"nc__title"}>
                      No comments yet. Be the first to leave feedback on this
                      endpoint
                    </div>
                  </div>
                ) : (
                  <div className={"mt-2"}>
                    {jobDetails?.comments?.length > 0 &&
                      displayedComments
                        ?.filter((comment) => comment?.status !== "hide")
                        .map((comment, index) => (
                          <CommentCardNew
                            data={{
                              first_name: comment?.first_name,
                              email: comment?.email,
                              comment: comment?.comment,
                              type: "jobs",
                            }}
                            comment={comment}
                            index={index}
                            newsId={jobId}
                          />
                        ))}
                  </div>
                )}
                {jobDetails?.comments?.length > 2 && (
                  <div
                    className={
                      "d-flex flex-row justify-content-center align-items-center"
                    }
                    style={{ marginTop: "12px", marginBottom: "33px" }}
                  >
                    <div
                      className={"show__more"}
                      onClick={() => setShowAllComments(!showAllComments)}
                    >
                      {showAllComments
                        ? "Show Less"
                        : `Show More (${jobDetails?.comments?.length - 2})`}
                    </div>
                  </div>
                )}
              </div>
              {/* related news */}

              {/* <JobViewCard data={{ type: "online" }} /> */}
              {/* <JobViewCard data={{ type: "model" }} /> */}
              {/* <NewsGroup
                data={{
                  titleName: "Recent View",
                  linkName: "",
                }}
              >
                <JobCard />
                <JobCard />
                <JobCard />
              </NewsGroup>

              <NewsGroup
                data={{
                  titleName: "Related Jobs",
                  linkName: "",
                }}
              >
                <JobCard />
                <JobCard />
                <JobCard />
              </NewsGroup> */}

              <div className="bottom-ad">
                <NewsViewLeftBottomAdd />
              </div>

              {/* <div className="bottom-ad-mobile">
                <HomePageCenterAdd />
              </div> */}
            </div>

            <div className={"gj__special-news-group"}>
              <NewsViewRightTopAdd data={{ mainLayerStyles: "mb-3" }} />
              <HotNewsSmall setMenuName={handleChildData} />
            </div>
          </div>
        </div>
        <Footer />
      </>
    </>
  );
};

export default withRouter(Index);
